import { ReactNode, useState } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { HOTKEYS_SCOPES } from "@hooks/keyboard/useKeyboardCommand";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import { TaskGroupFormModal } from "./TaskGroupFormModal";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";

interface Props {
    canManageTaskGroups: boolean;
    scope: "workspace" | "organization";
    children: (props: {
        search: string;
        canManageTaskGroups: boolean;
    }) => ReactNode;
}

export const TaskGroupsPage = ({
    canManageTaskGroups,
    scope,
    children,
}: Props) => {
    const [search, setSearch] = useState("");
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    return (
        <main>
            <HStack as="header" align="start" className="settings__header">
                <h3 className="settings__heading">Task groups</h3>
            </HStack>

            <TablePageHeader search={search} onSearchChange={setSearch}>
                {canManageTaskGroups && (
                    <WithHotkey
                        hotKey="alt+n"
                        hotKeyOptions={{
                            description: "Create task group",
                            scopes: [HOTKEYS_SCOPES.SETTINGS_MODAL],
                            preventDefault: true,
                        }}
                    >
                        <Button
                            variant="primary"
                            size="md"
                            onClick={() => setIsCreateModalOpen(true)}
                        >
                            Create task group
                        </Button>
                    </WithHotkey>
                )}
            </TablePageHeader>

            {children({ search, canManageTaskGroups })}

            <TaskGroupFormModal
                show={isCreateModalOpen}
                onHide={() => setIsCreateModalOpen(false)}
                scope={scope}
            />
        </main>
    );
};
